
//
document.querySelectorAll('.news-slider sl-carousel')?.forEach((slider) => {

    //
    let isDragging = false;

    //detect the start of a drag
    slider.addEventListener('mousedown', () => {
        isDragging = false;
    });

    //
    slider.addEventListener('mousemove', () => {
        isDragging = true;
    });

    //detect the end of a drag
    slider.addEventListener('mouseup', () => {
        setTimeout(() => {
            isDragging = false;
        }, 100);
    });

    //prevent anchor default action during a drag
    slider.querySelectorAll('a').forEach(anchor => {
        anchor.addEventListener('click', (event) => {
            if (isDragging) {
                event.preventDefault();
            }
        });
    });

    //
    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            if (entry.contentRect.width < 600) {
                slider.setAttribute('slides-per-page', '1');
            } else if (entry.contentRect.width < 850) {
                slider.setAttribute('slides-per-page', '2');
            } else {
                slider.setAttribute('slides-per-page', '3');
            }
        }
    });
    resizeObserver.observe(slider);
});
